const ApiURLs = {
  ApiUrl:  window.location.protocol + '//' + window.location.hostname +'/api',
  libraryApiUrl: "https://dev.library.cirma.org.gt/api/opac/v1/",
  cirmaDomainName: "https://dev.cirma.org.gt/",
  libraryDomainName: "https://dev.library.cirma.org.gt/",
  ApitamiLocalDomainName:  window.location.protocol + '//' + window.location.hostname +'/api',
  tamiLocalDomainName:  window.location.protocol + '//' + window.location.hostname,
  ApitamiDomainName:  window.location.protocol + '//' + window.location.hostname +'/api',
  tamiDomainName:  window.location.protocol + '//' + window.location.hostname ,
};

export default ApiURLs;
